import { render, staticRenderFns } from "./auth-registration.vue?vue&type=template&id=5523185b&scoped=true&"
import script from "./auth-registration.vue?vue&type=script&lang=js&"
export * from "./auth-registration.vue?vue&type=script&lang=js&"
import style0 from "./auth-registration.vue?vue&type=style&index=0&id=5523185b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5523185b",
  null
  
)

export default component.exports